import { captureException } from '@sentry/react';
import type { NextPage } from 'next';
import { StepBlackHero } from '../components/step-black-hero';
import { fetchContentfulPage } from '../lib/static/fetchStaticPage';
import type { StaticPageData } from '../lib/static/page';
import { ERRORS } from '../lib/utils/errors';
import { PAGE_OPTIONS } from '../lib/utils/page';
import { PageTemplate } from '../page-templates/generic-page';
export async function getStaticProps() {
  try {
    const slug = PAGE_OPTIONS.STEP_BLACK.slug;

    // get the page object from contentful
    const data = await fetchContentfulPage(slug);
    return {
      props: {
        data,
        slug
      },
      revalidate: 60 * 10 // 10 minutes
    };
  } catch (error) {
    if (error instanceof Error && error.message.startsWith(ERRORS.PAGE_NOT_FOUND)) {
      return {
        props: {},
        // return nothing so that we can render null if the page is not published
        revalidate: 60 * 10 // 10 minutes
      };
    }
    captureException(error);
    throw error;
  }
}
const Page: NextPage<StaticPageData> = ({
  data,
  slug
}) => {
  if (!data) return null;
  return <>
            <StepBlackHero data-sentry-element="StepBlackHero" data-sentry-source-file="blackcard.tsx" />
            <PageTemplate slug={slug} pageData={data} data-sentry-element="PageTemplate" data-sentry-source-file="blackcard.tsx" />
        </>;
};
export default Page;